import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {environment} from 'src/environments/environment';
import * as moment from 'moment';
import {EventsManager} from 'src/app/services/events.manager';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [NgIf]
})

export class FooterComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);

  public eventsManager = inject(EventsManager);

  public year: number = 0;
  public environment: any = environment;
  public footerText: string = '';

  public ngOnInit(): void {
    this.year = moment().year();

    this.eventsManager.homePageDetailUpdated
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => {
        this.footerText = this.eventsManager?.homePageDetails?.salesPlanMarketingDetails?.footer.at(0)?.value.at(0);
      });
  }
}
